import React from "react";

const FootBar = () => {
  return (
    <footer className="footer" >
      {/* <div className="text-center">
        <span className="text-secondary">UniNotas © 2020</span>
      </div> */}
    </footer>
  );
};

export default FootBar;
